import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./style.scss";

const SliderDots = ({ slides, activeSlide }) => {
  return (
    <div className="slider-dots">
      {slides.map((_, i) => {
        const dotClasses = classNames(
          "dot",
          `dot--${activeSlide === i ? "active" : "inactive"}`
        );
        return <span key={i} className={dotClasses} />;
      })}
    </div>
  );
};

SliderDots.propTypes = {
  slides: PropTypes.array,
  activeSlide: PropTypes.number,
};
SliderDots.defaultProps = {
  slides: [],
  activeSlide: 0,
};

export default SliderDots;
